var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.3496C0 10.2034 6.6038 3.59961 14.75 3.59961H42.1429C43.3066 3.59961 44.25 4.54301 44.25 5.70675V11.5965L14.1409 11.5965C12.6862 11.5965 11.507 12.7758 11.507 14.2305C11.507 15.6851 12.6862 16.8644 14.1409 16.8644L46.1024 16.8644C46.18 16.8644 46.2568 16.861 46.3326 16.8545L47.2509 16.8545C48.9274 16.8545 50.5353 17.5205 51.7208 18.706C52.9063 19.8915 53.5723 21.4993 53.5723 23.1759V27.0378H41.1367C37.6622 27.0378 33.7617 29.6707 33.7617 34.1794V41.6741C33.7617 46.1828 37.6622 48.8157 41.1367 48.8157H53.5723V52.6759C53.5723 54.3524 52.9063 55.9603 51.7208 57.1458C50.5353 58.3313 48.9274 58.9973 47.2509 58.9973L6.32143 58.9973C4.64488 58.9973 3.037 58.3313 1.8515 57.1458C0.666006 55.9603 0 54.3525 0 52.6759V18.3496ZM41.1387 32.3063H55.8887C57.0524 32.3063 57.9958 33.1452 57.9958 34.18V41.6748C57.9958 42.7096 57.0524 43.5485 55.8887 43.5485H41.1387C39.9749 43.5485 39.0315 42.7096 39.0315 41.6748V34.18C39.0315 33.1452 39.9749 32.3063 41.1387 32.3063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWallet);
export default __webpack_public_path__ + "static/media/Mobile Wallet.27ab9eb6175b638c7de594c038f43aab.svg";
export { ForwardRef as ReactComponent };